@if (this.rides().length <= 0 && !firstTime() && !(loaderState$ | async)) {
  <app-no-records minHeight="calc(100vh - 350px)"></app-no-records>
} @else {
  <div [class]="'flex flex-column gap-spacing-xs rides-component main-wrapper pb-spacing-3xs ' + view()">
    @if (rides().length > 0) {
      <div class="item-wrapper header-item-wrapper">
        <div class="item header-item">
          <div
            class="grid-layout-container"
            [ngClass]="{ 'grid-layout-actions-container-xs': !appSetting['hasDriverMessagingPermission'] && !appSetting['hasGuardianMessagingPermission'] }">
            <h5 class="mb-0 py-spacing-md px-spacing-xl label-large-medium text-primary-color ride-serial">#</h5>
            @if (currentRole == userRole.Client) {
              <h5 class="mb-0 py-spacing-md px-spacing-xl label-large-medium text-primary-color ride-students">Students</h5>
            }
            <h5 class="mb-0 py-spacing-md px-spacing-xl label-large-medium text-primary-color ride-info">{{ currentRole == userRole.Client ? "Ride Type" : "Ride ID" }}</h5>
            <h5 class="mb-0 py-spacing-md px-spacing-xl label-large-medium text-primary-color ride-time">{{ isPendingRides ? "Time / Date" : "Time" }}</h5>
            <h5 class="mb-0 py-spacing-md px-spacing-xl label-large-medium text-primary-color ride-status">Status</h5>
            <h5 class="mb-0 py-spacing-md px-spacing-xl label-large-medium text-primary-color ride-timeline text-center">Stops</h5>
            <h5 class="mb-0 py-spacing-md px-spacing-xl label-large-medium text-primary-color driver-details">Contractor</h5>
            <h5 class="mb-0 py-spacing-md px-spacing-xl label-large-medium text-primary-color client-details">Blueprint</h5>
            @if (appSetting.hasCameraIconPermission) {
              <h5 class="mb-0 py-spacing-md px-spacing-xl label-large-medium text-primary-color ride-status camera-status">Camera</h5>
            }
            <h5
              class="mb-0 py-spacing-md px-spacing-xl label-large-medium text-primary-color actions-container hidden md:block"
              [ngClass]="{ 'actions-container-xs': !appSetting['hasDriverMessagingPermission'] && !appSetting['hasGuardianMessagingPermission'] }">
              Actions
            </h5>
          </div>
        </div>
      </div>
    }
    <p-virtualScroller
      #pVirtualScroller
      [items]="rides()"
      scrollHeight="450px"
      [itemSize]="100"
      [delay]="250"
      [lazy]="true">
      <ng-template
        let-ride
        #item
        let-options="options">
        <div class="virtual-row">
          <div
            class="item-wrapper"
            [ngClass]="{ active: activeRideId() == ride.original_ride_id }">
            <app-ride-item
              [activeRide]="activeRideId() == ride.original_ride_id"
              [index]="options.index"
              [ride]="ride"
              [isPendingRides]="isPendingRides">
            </app-ride-item>
          </div>
          <div
            class="item-wrapper skeleton-wrapper"
            [class.visible]="isLoadingMore() && options.last">
            <div class="item skeleton-item">
              <div class="skeleton-content">
                <p-skeleton
                  width="24px"
                  height="24px"
                  borderRadius="4px"></p-skeleton>
                <p-skeleton
                  class="w-12rem"
                  width="100%"
                  height="1.25rem"
                  borderRadius="8px"></p-skeleton>
                <p-skeleton
                  class="w-12rem lg"
                  width="100%"
                  height="1.25rem"
                  borderRadius="8px"></p-skeleton>
                <div class="skeleton-group">
                  <p-skeleton
                    shape="circle"
                    size="1.5rem"></p-skeleton>
                  <p-skeleton
                    class="separator-skeleton"
                    width="100%"
                    height=".25rem"
                    borderRadius="6px"></p-skeleton>
                  <p-skeleton
                    shape="circle"
                    size="1.5rem"></p-skeleton>
                  <p-skeleton
                    class="separator-skeleton"
                    width="100%"
                    height=".25rem"
                    borderRadius="6px"></p-skeleton>
                  <p-skeleton
                    shape="circle"
                    size="1.5rem"></p-skeleton>
                  <p-skeleton
                    class="separator-skeleton"
                    width="100%"
                    height=".25rem"
                    borderRadius="6px"></p-skeleton>
                  <p-skeleton
                    shape="circle"
                    size="1.5rem"></p-skeleton>
                </div>
                <p-skeleton
                  class="w-8rem"
                  width="100%"
                  height="1.25rem"
                  borderRadius="8px"></p-skeleton>
                <p-skeleton
                  class="w-8rem lg"
                  width="100%"
                  height="1.25rem"
                  borderRadius="8px"></p-skeleton>
                <div class="skeleton-actions">
                  <p-skeleton
                    shape="square"
                    size="2rem"></p-skeleton>
                  <p-skeleton
                    shape="square"
                    size="2rem"></p-skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </p-virtualScroller>
  </div>
}
